var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown',{staticClass:"user-avatar",attrs:{"trigger":"click"},on:{"command":_vm.handle}},[_c('div',[_c('el-avatar',{attrs:{"size":"small","icon":"el-icon-user-solid"}})],1),_c('el-dropdown-menu',{staticClass:"logout",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"logout"}},[_vm._v(" logout ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }